// baseAccessCopy.js — user-facing copy for base access locks (not a 14-day trial).

export const BASE_LOCKED_TITLE = 'This base is locked';

export function formatBaseLockedNotice() {
  return 'This base is locked. Choose a plan to restore access.';
}

export function formatBaseLockedOwnerCopy(baseTitle) {
  const title = String(baseTitle || 'this base').trim() || 'this base';
  return `Choose a plan to restore access to ${title}.`;
}

export function formatBaseLockedMemberCopy({ ownerName, baseTitle } = {}) {
  const owner = String(ownerName || 'the owner').trim() || 'the owner';
  const title = String(baseTitle || 'this base').trim() || 'this base';
  return `This base is locked. Ask ${owner} to choose a plan for ${title}.`;
}

export function formatBaseLockedInviteCopy() {
  return 'This base is locked. Choose a plan to invite members.';
}
